document.querySelectorAll( '.b-step-cards' ).forEach( ( block ) => {

	/////////////////////
	// BLOCK CODE HERE //
	/////////////////////

} );
